import React, { useEffect, useState } from 'react';
import DropdownTreeSelect from 'react-dropdown-tree-select';
import 'react-dropdown-tree-select/dist/styles.css';
import './index.css';

interface IProps {
  onChange: any;
  disabled?: boolean;
  loading: boolean;
  placeholder?: React.ReactNode;
  noOptionsMessage?: React.ReactNode;
  data: any;
  clear?: boolean;
}

const SelectTree = (props: IProps) => {
  const [data, setData] = useState([]);
  useEffect(() => {
    setData(props.data);
  }, [props.data]);

  useEffect(() => {
    if (props.clear) {
      let newArray = props.data;
      newArray.forEach((item: any) => (item.checked = false));
      setData(newArray);
    }
  }, [props.clear, props.data]);

  const handleChange = (currentNode: any, selectedValues: any) => {
    if (props.onChange) {
      let newArray = data.filter((item: any) => item.id !== selectedValues[0].id);
      newArray.push(selectedValues[0]);
      setData(newArray);
      const getOnlyChecked = newArray.filter((item: any) => item.checked);
      props.onChange(getOnlyChecked);
    }
  };
  return (
    <DropdownTreeSelect
      keepTreeOnSearch={true}
      clearSearchOnChange={true}
      disabled={props.disabled || props.loading}
      noMatchesText={props.noOptionsMessage ? props.noOptionsMessage : 'Nenhum resultado encontrado.'}
      placeholderText={props.loading ? 'Carregando...' : props.placeholder ? props.placeholder : 'Selecione'}
      data={data}
      onChange={handleChange}
      className={'mdl-demo'}
    />
  );
};

export default SelectTree;
